/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, OnInit } from '@angular/core';

import { DialogRef } from '@ngneat/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'bkg-carservices-discount-dialog',
  templateUrl: './carservices-discount-dialog.component.html',
})
export class CarservicesDiscountDialogComponent implements OnInit {
  title: string;
  body: string;

  constructor(public ref: DialogRef) {}

  ngOnInit(): void {
    this.title = this.ref.data?.title as string;
    this.body = this.ref.data?.body as string;
  }

  onClickClose(): void {
    this.ref.close(false);
  }
}
